import { render, staticRenderFns } from "./DownloadOldOrdersPopup.vue?vue&type=template&id=2d8c5ed2&scoped=true"
import script from "./DownloadOldOrdersPopup.vue?vue&type=script&lang=js"
export * from "./DownloadOldOrdersPopup.vue?vue&type=script&lang=js"
import style0 from "./DownloadOldOrdersPopup.vue?vue&type=style&index=0&id=2d8c5ed2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d8c5ed2",
  null
  
)

export default component.exports